import { useState } from 'react';
import { Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { ServiceCategoryForm } from './service-category.form';
import { SiTrackPage } from '../../../components/si-track-page';
import { serviceFormSchema } from '../service/service-form.schema';
import { ServiceCategory } from '../../../models/masters/service-category';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { serviceCategoryApiKeyStore } from '../../../api/masters/service-category-api-key-store';
import { categoryFormSchema } from './service-category-form.schema';
import { UserPermissionName } from '../../../models/user-permission-name';
import { GuardedComponent } from '../../../components/guarded-component';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const ServiceCategoryPage = () => {
  const [editItem, setEditItem] = useState<Partial<ServiceCategory>>();

  const handleEditDivision = (category: ServiceCategory) => {
    setEditItem(category);
  };
  const handleEditClose = () => {
    setEditItem(undefined);
  };
  const handleCreateDivision = () => {
    setEditItem({ isActive: true });
  };
  return (
    <SiTrackPage
      title="Service Categories"
      actionButton={
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_SERVICECATEGORY]}>
          <Button
            size="small"
            variant="contained"
            disableElevation={true}
            startIcon={<AddIcon />}
            onClick={handleCreateDivision}
          >
            Add Category
          </Button>
        </GuardedComponent>
      }
    >
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='service_category'
          dataItemKey="serviceCategoryID"
          columns={columns}
          queryConfig={serviceCategoryApiKeyStore.getServiceCategories()}
          onEdit={handleEditDivision}
          deleteMutationConfig={(deleteItem) =>
            serviceCategoryApiKeyStore.deleteServiceCategory(deleteItem.serviceCategoryID)
          }
          actionPermissions={{
            edit: UserPermissionName.EDIT_SERVICECATEGORY,
            delete: UserPermissionName.DELETE_SERVICECATEGORY,
            export: UserPermissionName.DOWNLOAD_GRID,
          }}
        />
        {editItem && (
          <SaveHookFormDialog
            title={editItem.serviceCategoryID ? 'UPDATE SERVICE CATEGORY' : 'CREATE SERVICE CATEGORY'}
            config={{
              saveConfig: editItem.serviceCategoryID
                ? serviceCategoryApiKeyStore.updateServiceCategory()
                : serviceCategoryApiKeyStore.createServiceCategory(),
              invalidateRoute: () => serviceCategoryApiKeyStore.getServiceCategories(),
            }}
            data={editItem}
            yupSchema={categoryFormSchema}
            onClose={handleEditClose}
            size="xs"
          >
            <ServiceCategoryForm editItem={editItem} />
          </SaveHookFormDialog>
        )}
      </Paper>
    </SiTrackPage>
  );
};
